import { ReactNode } from 'react';

import DomipProviderContext from 'features/systems/domip/providers/contexts/domip-provider-context';
import useDomipProviderState from 'features/systems/domip/providers/states/domip-provider-state';

type Props = {
  children: ReactNode;
};

const DomipProvider = ({ children }: Props): React.JSX.Element => (
  <DomipProviderContext.Provider value={useDomipProviderState()}>{children}</DomipProviderContext.Provider>
);

export default DomipProvider;
